import { IconBase } from './IconBase'

type IconEditProps = React.ComponentProps<'svg'>

export const IconEdit = (props: IconEditProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 32 32" {...props}>
      <circle cx="16" cy="16" r="16" fill="white" />
      <path
        d="M21.2188 8C20.8776 8 20.5364 8.13029 20.276 8.39062L19.3333 9.33333L22.6667 12.6667L23.6094 11.724C24.13 11.2033 24.13 10.3592 23.6094 9.83854L22.1615 8.39062C21.9011 8.13029 21.5599 8 21.2188 8ZM18 10.6667L10 18.6667L11 19L11.3333 20.6667L13 21L13.3333 22L21.3333 14L18 10.6667ZM8.76823 21.4349L8.02474 23.5391C8.0082 23.5796 7.9998 23.6229 8 23.6667C8 23.7551 8.03512 23.8399 8.09763 23.9024C8.16015 23.9649 8.24493 24 8.33334 24C8.37473 24.0002 8.41579 23.9927 8.45443 23.9779L10.5651 23.2318L8.76823 21.4349Z"
        fill="url(#paint0_linear_2_5474)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2_5474"
          x1="8"
          y1="15.6522"
          x2="23.9999"
          y2="15.6522"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF7575" />
          <stop offset="1" stopColor="#FFA800" />
        </linearGradient>
      </defs>
    </IconBase>
  )
}
